
<template>
  <div class="Manage_3">
    <div class="tab_Top">
      <el-menu
        :default-active="activeIndex"
        class="el-menu-demo"
        mode="horizontal"
        @select="handleSelect_top">
        <el-menu-item index="1">销售线索</el-menu-item>
        <el-menu-item index="2">客户管理</el-menu-item>
        <el-menu-item index="3">订单管理</el-menu-item>
        <el-menu-item index="4">合同管理</el-menu-item>
        <el-menu-item index="5">数据报表</el-menu-item>
      </el-menu>
      <div class="Men_1">
        说明：这里可以管理线上平台销售的订单与线下个人创建的全部订单
      </div>
    </div>
    <div class="tab_Bor"> 
      <div class="T1 bord">
        <el-tooltip class="item" effect="dark" content="订单的来源" placement="top">
          <span style="float:left;margin-right:10px">订单来源<i class="el-icon-question"></i>:</span>
        </el-tooltip>
        <div class="T2" style="margin-left:24px">
          <div class="Tuyiiu" @click="Activ(1, 0)" :class="0 == leads_source_value ? 'Actits' : ''">全部</div>
          <div @click="Activ(1 , i)" :class="i == leads_source_value ? 'Actits' : ''" 
            v-for="(item, i) in Pay_type" :key="i" :label="item" :value="i">{{item}}</div>
        </div>
      </div>
      <div class="T1 bord">
        <el-tooltip class="item" effect="dark" content="销售的项目" placement="top">
          <span style="float:left;margin-right:10px">销售项目<i class="el-icon-question"></i>:</span>
        </el-tooltip>
        <div class="T2" style="margin-left:24px">
          <div class="Tuyiiu" @click="Activ(2, 0)" :class="0 == leads_demand_value ? 'Actits' : ''">全部</div>
          <div @click="Activ(2 , item.goods_id)" :class="item.goods_id == leads_demand_value ? 'Actits' : ''" 
            v-for="item in leads_source" :key="item.goods_id" :label="item.goods_name" :value="item.goods_id">{{item.goods_name}}</div>
        </div>
      </div>
      <div class="T1 bord">
        <el-tooltip class="item" effect="dark" content="支付的方式" placement="top">
          <span style="float:left;margin-right:10px">支付方式<i class="el-icon-question"></i>:</span>
        </el-tooltip>
        <div class="T2" style="margin-left:24px">
          <div class="Tuyiiu" @click="Activ(3, 0)" :class="0 == leads_worth_value ? 'Actits' : ''">全部</div>
          <div @click="Activ(3 , i)" :class="i == leads_worth_value ? 'Actits' : ''" 
            v-for="(item, i) in Pay_method" :key="i" :label="item" :value="i">{{item}}</div>
        </div>
      </div>
      <div style="display:flex">
        <div class="T1 bord" style="float:left;flex:2">
            <span style="float:left;">创建时间：</span>
          <div style="float:left;" class="Topo Tuyiiu">
            <el-date-picker v-model="Months1" type="date" placeholder="选择时间" :clearable="false"></el-date-picker>
            <span style="margin: 0 15px;display: inline;">至</span>
            <el-date-picker v-model="Months2" type="date" placeholder="选择时间" :clearable="false"></el-date-picker>
          </div>
        </div>
        <div class="T1 bord" style="flex:2">
            <span style="float:left">订单金额：</span>
          <div style="float:left;" class="Topo dasrttr">
            <el-input v-model="Months3" placeholder="输入具体数值"></el-input>
            <span style="margin: 0 15px 0 15px;display: inline;">至</span>
            <el-input v-model="Months4" placeholder="输入具体数值"></el-input>
          </div>
        </div>
        <div style="flex:1"></div>
      </div>
      <div class="T1">
        <el-tooltip class="item" effect="dark" content="Top Center 提示文字" placement="top">
          <span style="float:left;">筛选：&nbsp;</span>
        </el-tooltip>
        <div class="T_sel">
          <el-select v-model="sa_id" placeholder="服务商" style=" width: 200px">
            <el-option v-for="item in BusinessList" :key="item.id" :label="item.username" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="T_sel">
          <el-select v-model="te_id" placeholder="站点" style=" width: 200px">
            <el-option v-for="item in SiteList" :key="item.site_id" :label="item.name" :value="item.site_id"> </el-option>
          </el-select>
        </div>
        <div class="T_sel">
          <el-select v-model="st_id" placeholder="支付状态">
            <el-option v-for="(item,i) in OPzt" :key="i" :label="item" :value="i"></el-option>
          </el-select>
        </div>
        <div class="T_sel">
          <el-select v-model="co_id" placeholder="接单状态">
            <el-option
              v-for="(item,i) in OPzt2" :key="i" :label="item" :value="i"></el-option>
          </el-select>
        </div>
        <div class="T_sel">
          <el-select v-model="ba_id" placeholder="退款">
            <el-option
              v-for="(item,i) in OPzt3" :key="i" :label="item" :value="i"></el-option>
          </el-select>
        </div>
        <div class="T_sel">
          <el-select v-model="pa_id" placeholder="付款形式">
            <el-option
              v-for="(item,i) in OPzt4" :key="i" :label="item" :value="i"></el-option>
          </el-select>
        </div>
        <div>
          <div class="Actit" @click="AddXs(6)"  style="margin-left:20px;cursor: pointer;">筛选</div>
          <div class="Actit dsdsdsdaaa" @click="AddXs(10)"  style="margin-left:20px;cursor: pointer;">重置</div>
        </div>
      </div>
    </div>

    <div class="Tables">
       <div class="Tab_T" @click="AddXs(5)" v-if="TextMoMo('order:order:add')"><i class="el-icon-plus"></i>创建订单</div>
      <div class="Tab_T Tab_y" @click="export2Excel"  v-if="TextMoMo('workbench:sales:middle:add')"><i class="el-icon-download"></i>导出</div>
      <div class="Tab_T Tab_y" style="border: 1px solid #FF4D4F;color:#FF4D4F"  
        v-if="TextMoMo('order:order:del')" @click="Add_Del(2)"><i class="el-icon-delete"></i>批量删除</div>
        <div class="el_seso"><i class="el-icon-search" @click="inpu_sech"></i></div>
        <div class="dsds">
          <el-input v-model="input_seach" placeholder="请输入内容" @keyup.enter.native="inpu_sech()"></el-input>
        </div>
        <div>
          <el-table
            :data="tableData"
            class="table"
            ref="multipleTable"
            @row-click="handleRowClick"
            header-cell-class-name="table-header"
            @selection-change="handhange">
            <el-table-column
              type="selection"
              width="55"
              align="center"></el-table-column>
            <el-table-column
              prop="id"
              label="ID"
              width="55"
              align="center"></el-table-column>
            <el-table-column align="center" prop="customer.username" label="买家姓名"></el-table-column>
            <el-table-column align="center" prop="customer.mobile" label="联系方式"></el-table-column>
            <el-table-column align="center" prop="order_no" label="订单号" width="200"></el-table-column>
            <el-table-column align="center" prop="goodsone.goods_name" label="购买项目"></el-table-column>
            <el-table-column align="center" prop="pay_price" label="支付金额"></el-table-column>
            <el-table-column align="center" prop="unpaid.unpaid_money" label="剩余金额"></el-table-column>
            <el-table-column align="center" prop="pay_method_text" label="支付方式"></el-table-column>
            <el-table-column align="center" prop="is_confirm_text" label="接单状态"></el-table-column>
            <el-table-column align="center" prop="back_status_text" label="退款列表"></el-table-column>
            <el-table-column label="操作" align="center" width="240">
              <template #default="scope" >
                  <!-- <div class="el_butto" >
                    <el-button type="text" @click="Handlbchak(3, scope.row)" v-if="TextMoMo('order:order:read')">查看</el-button>
                    <el-button type="text" v-if="!TextMoMo('order:order:read')">查看</el-button>
                  </div> -->
                  <div class="el_butto" >
                    <el-button type="text" @click="Handlbchak(1, scope.row)" v-if="TextMoMo('order:order:edit')">编辑</el-button>
                    <el-button type="text" v-if="!TextMoMo('order:order:read')">查看</el-button>
                  </div>
                <div class="el_butto rere" >
                    <el-button
                    type="text" v-if="TextMoMo('order:order:del')"
                    class="red"
                    @click="HanDel(scope.$index, scope.row)"
                    >删除</el-button>
                </div>
                <div class="Spliiks" style="width: 40%;float: right">
                  <el-dropdown split-button type="primary" @click="handleClick" trigger="click">
                    更多
                    <template #dropdown>
                      <el-dropdown-menu>
                        <el-dropdown-item v-if="TextMoMo('order:order:edit')">
                         <div class="el_butto dssadd" style="margin:5px 0px 5px 0">
                            <button type="text" @click="Handlbchak(1, scope.row)">编辑</button>
                          </div>                          
                        </el-dropdown-item >
                        <el-dropdown-item v-if="TextMoMo('order:order:confirm')">
                         <div class="el_butto dssadd" style="margin:5px 0px 5px 0">
                            <button type="text" @click="HanEdit_SJ2(scope.$index, scope.row)">接单</button>
                          </div>                          
                        </el-dropdown-item >
                        <el-dropdown-item v-if="TextMoMo('order:order:transfer')">
                          <div class="el_butto dssadd" style="margin:5px 0 5px 0">
                            <button type="text" @click="HanEdit_SJ3(1, scope.row)">转移</button>
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <div class="el_butto dssadd" style="margin:5px 0 5px 0">
                            <button type="text" @click="Handlbchak(2, scope.row)">维护</button>
                          </div>    
                        </el-dropdown-item>     
                        <el-dropdown-item>
                          <div class="el_butto dssadd" style="margin:5px 0 5px 0">
                            <button type="text" @click="Handlupgrade(scope.row)">升级</button>
                          </div>    
                        </el-dropdown-item>                
                      </el-dropdown-menu>
                    </template>
                  </el-dropdown>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="block">
            <el-pagination
              background
              @current-change="handleCurrentChange1"
              :current-page="currentPage1"
              :page-size="page.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="total1">
            </el-pagination>
          </div>
        </div>

    </div>

    <!--添加线索来源-->
    <el-dialog title="添加线索来源" v-model="dialogVisible3" width="35.3%">
      <div class="Tabbl">
        <el-table
        :data="Categ"
        class="table"
        header-cell-class-name="table-header"
        @selection-change="handleSelectionChange">
        <el-table-column label="线索类型" width="240" align="center" >
          <template #default="scope" >
              <div class="El_pop dasdasd">
                <el-input :disabled = "scope.row.type == 'default' ? true : false"  v-model="scope.row.content" placeholder="类别"></el-input>
              </div>
          </template>
        </el-table-column>
        <el-table-column label="设置" width="180" align="center">
            <template #default="scope">
            <div v-if="scope.row.type == 'default'">预设</div>
            <div v-if="scope.row.type == 'custom'">自定义</div>
            </template>
        </el-table-column>
        <el-table-column label="是否启用" width="100">
          <template #default="scope" >
            <div class="el_butto rere dsdtrt">
                <el-switch
                
                  :disabled="scope.row.type == 'default' ? true : false "
                  v-model="scope.row.status"
                  active-value = 'normal'
                  inactive-value = 'hidden'
                  active-color="#1890FF"
                  @change="changeSwitch($event,scope.row,scope.$index)"
                  inactive-color="#dcdfe6">
                </el-switch>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center" >
          <template #default="scope" >
            <div class="el_butto rere dsdtrt">
                <i class="el-icon-delete" @click="haeDete(scope.$index, scope.row)"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <div class="Y_ids" @click="Add_leibie"><i class="el-icon-plus"></i>创建内容</div>
      <div class="Dityo">
        <div class="dialog-footer">
          <el-button @click="dialogVisible3 = false">取 消</el-button>
          <el-button type="primary" @click="NabCH_BTN()">确 定</el-button>
        </div>
      </div>  

    </el-dialog>
    <!--添加线索来源-->

    <!--全部线索类型管理-->
    <el-dialog title="全部线索类型管理" v-model="dialogVisible2" width="35.3%"> 
      <div class="Tabbl">
        <el-table
        :data="Categ2"
        class="table"
        header-cell-class-name="table-header"
        @selection-change="handleSelectionChange">
        <el-table-column label="线索类型" width="240" align="center" >
          <template #default="scope" >
              <div class="El_pop dasdasd">
                <el-input type="number" :disabled = "scope.row.type == 'default' ? true : false"  v-model="scope.row.content" placeholder="类别"></el-input>
              </div>
          </template>
        </el-table-column>
        <el-table-column label="设置" width="180" align="center">
            <template #default="scope">
            <div v-if="scope.row.type == 'default'">预设</div>
            <div v-if="scope.row.type == 'custom'">自定义</div>
            </template>
        </el-table-column>
        <el-table-column label="是否启用" width="100">
          <template #default="scope" >
            <div class="el_butto rere dsdtrt">
                <el-switch
                
                  :disabled="scope.row.type == 'default' ? true : false "
                  v-model="scope.row.status"
                  active-value = 'normal'
                  inactive-value = 'hidden'
                  active-color="#1890FF"
                  @change="changeSwitch($event,scope.row,scope.$index)"
                  inactive-color="#dcdfe6">
                </el-switch>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="100" align="center" >
          <template #default="scope" >
            <div class="el_butto rere dsdtrt">
                <i class="el-icon-delete" @click="haeDete2(scope.$index, scope.row)"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
      </div>

      <div class="Y_ids" @click="Add_leibie2"><i class="el-icon-plus"></i>创建内容</div>
      <div class="Dityo">
        <div class="dialog-footer" style="margin-bottom:20px">
          <el-button @click="dialogVisible2 = false">取 消</el-button>
          <el-button type="primary" @click="NabCH_BTN2()">确 定</el-button>
        </div>
      </div>  

    </el-dialog>
    <!--全部线索类型管理-->

    <!-- 接单 -->
    <el-dialog title="接单" v-model="editVisible2" width="30%" class="">
        <el-form ref="form" label-width="100px">
          <div class="DDGGD">
            <el-form-item label="服务周期：">
              <el-input v-model="TA_name22" placeholder="填写服务周期，实例30"></el-input>
            </el-form-item>
            <el-form-item label="周期类型：">
                <el-radio v-model="radio1" label="天">天</el-radio>
                <el-radio v-model="radio1" label="月">月</el-radio>
            </el-form-item>
            <el-form-item label="用户姓名：">
              <el-input v-model="TA_name11" placeholder="填写用户姓名"></el-input>
            </el-form-item>
          </div>
        </el-form>
        <template #footer>
          <span class="dialog-footer" style="margin-bottom:28px">
            <el-button @click="editVisible2 = false" style="margin-right:15px">取 消</el-button>
            <el-button type="primary" @click="saveEdit2()">确 认</el-button>
          </span>
        </template>
    </el-dialog>
    <!-- 接单 -->

    <!-- 转移 -->
    <el-dialog title="转移" v-model="editVisible3" width="30%" class="">
        <el-form ref="form" label-width="100px">
          <div class="DDGGD">
            <el-form-item label="订单编号：">
              <el-input v-model="TA_name222" disabled placeholder="填写订单编号"></el-input>
            </el-form-item>
            <el-form-item label="商品名称：">
               <el-input v-model="TA_name111" disabled placeholder="填写商品名称"></el-input>
            </el-form-item>
            <el-form-item label="服务商：">
              <div class="Rtty Riiiu">
                <el-select v-model="TA_name333" placeholder="请选择可见员工">
                    <el-option v-for="item in Fwus_list" :key="item.id" :label="item.username" :value="item.id"></el-option>
                </el-select>
              </div>
            </el-form-item>
          </div>
        </el-form>
        <template #footer>
          <span class="dialog-footer" style="margin-bottom:28px">
            <el-button @click="editVisible3 = false" style="margin-right:15px">取 消</el-button>
            <el-button type="primary" @click="saveEdit3()">确 认</el-button>
          </span>
        </template>
    </el-dialog>
    <!-- 转移 -->

    <!-- 导入 -->
    <el-dialog title="导入文件" v-model="editVisible_DEX" width="31%" class="">
        <el-form ref="form" label-width="120px">
          <div class="DDGGD">
          <el-form-item label="模板：">
             <el-button type="primary"> <a style="color:#fff" href="./w3school_logo.xlsx" download="w3school_logo.xlsx">下载模板</a></el-button>
          </el-form-item>
          <el-form-item label="选择导入文件：" style="margin-bottom:5px">
            <div class="el-form-item__content">
              <el-upload
                  accept=".xls,.xlsx"
                  :action="upload"
                  :headers="heads"
                  :multiple="false"
                  :file-list="fileList"
                  :on-success="UP_Success3"
                  :on-remove="fileRemove">
                  <el-button size="small" type="primary">选择文件</el-button>
                  <div class="el-upload__tip">一次只能上传一个xls/xlsx文件，且不超过10M</div>
              </el-upload>

          </div>
          </el-form-item>
          <el-form-item label="可见员工：">
            <div class="Rtty Riiiu">
              <el-select v-model="File_Yid" multiple placeholder="请选择可见员工">
                  <el-option v-for="item in StaFFList" :key="item.id" :label="item.realname" :value="item.id"></el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item label="可见部门：">
            <div class="Rtty Riiiu">
              <el-cascader
                :options="DementList"
                v-model="File_Bid"
                :props="{ multiple: true, checkStrictly: true, label : 'name', value: 'id'}"
                @change="Handmuiksd2"
                clearable
              ></el-cascader>
            </div>
          </el-form-item>
          </div>
        </el-form>
        <template #footer>
          <span class="dialog-footer" style="margin-bottom:28px">
            <el-button @click="editVisible_DEX = false" style="margin-right:15px">取 消</el-button>
            <el-button type="primary" @click="File_Sure()">确 认</el-button>
          </span>
        </template>
      

    </el-dialog>
    <!-- 导入 -->

    <!-- 创建线索 -->
    <div ref="rightPanel" v-if="show1" class="rightPanel-container show">
          <div class="rightPanel-background"/>
          <div style="height:1100px;width: 822px;position: fixed;top: 0;right: 0;z-index:999;" >
            <el-scrollbar style="height:100%">
              <div class="rightPanel" style="width:822px;max-width: 822px;height: 690px;padding-bottom: 270px;">
                <div class="Rig_1" v-if="chakan111 == 1">创建订单<i class="el-icon-close" @click="Close"  style="float:right;padding:20px 50px;cursor: pointer;"></i></div>
                <div class="Rig_1" v-if="chakan111 == 0">编辑订单<i class="el-icon-close" @click="Close"  style="float:right;padding:20px 50px;cursor: pointer;"></i></div>
                <div style="margin:0 0 18px 24px " v-if="chakan111 == 0">
                  <el-menu
                    :default-active="acndex"
                    class="el-menu-demo"
                    mode="horizontal"
                    @select="handleSelect">
                    <el-menu-item index="1">销售线索</el-menu-item>
                    <el-menu-item index="2">客户管理</el-menu-item>
                    <el-menu-item index="3">订单管理</el-menu-item>
                    <el-menu-item index="4">跟进记录</el-menu-item>
                  </el-menu> 
                </div>
                <div class="Rig_A" v-if="info_Show == 0">
                    <div style="overflow:hidden">
                        <div style="width:50%;float:left">
                            <div class="Rig_D">
                                <div class="Rig_Ddd" > 
                                  <span style="color:#FF4D4F">* </span>姓名：</div>
                                <div class="Rtty">
                                <el-input v-model="Valuea_Xiansuo.username" placeholder="" disabled class="El_ii"></el-input>
                                </div>
                            </div>
                        </div>
                        <div style="width:50%;float:left">
                            <div class="Rig_D">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 联系方式：</div>
                                <div class="Rtty">
                                <el-input v-model="Valuea_Xiansuo.mobile" placeholder="" disabled class="El_ii"></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="overflow:hidden">
                        <div style="width:50%;float:left">
                            <div class="Rig_D">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 需求来源：</div>
                                <el-select v-model="Valuea_Xiansuo.source_id" placeholder="" disabled>
                                  <el-option v-for="item in leads_source" :key="item.value" :label="item.content" :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div style="width:50%;float:left">
                            <div class="Rig_D ">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 需求价值：</div>
                                <el-select v-model="Valuea_Xiansuo.worth_id" placeholder="" disabled>
                                    <el-option v-for="item in leads_worth" :key="item.value" :label="item.content" :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>

                    <div class="Rig_D " style="width:95%">
                      <div class="Rig_Ddd" >需求项目：</div>
                      <div class="Rtty" style="clear:both">
                        <el-select v-model="valueA_3" multiple disabled >
                            <el-option v-for="item in leads_demand" :key="item.value" :label="item.content" :value="item.value"></el-option>
                        </el-select>
                      </div>
                    </div> 
                    <div class="Rig_D" style="width: 98%;">
                        <div class="Rig_Ddd" >描述（选填）：</div>
                        <div class="Rtty">
                            <el-input type="textarea" style="width: 97%;" v-model="Valuea_Xiansuo.description" placeholder="" disabled ></el-input>           
                        </div>
                    </div>
                    <div>
                      <div class="Rig_Ddd" >图片线索（选填）</div>
                      <div class="Rtty" style="clear:both">
                        <img class="Rtt_im22g" v-for="item in full_avatar" :key="item" :label="item" :value="item" :src="item" />
                      </div>
                    </div> 
                    <div class="BCSZ" style="background:#fff;color:#595959;border: 1px solid #D9D9D9;margin-right:30px" @click="show1 = false">取消</div>
                </div>
                <div class="Rig_A" v-if="info_Show == 1">
                    <div style="overflow:hidden">
                        <div style="width:50%;float:left">
                            <div class="Rig_D">
                                <div class="Rig_Ddd" > 
                                  <span style="color:#FF4D4F">* </span>姓名：</div>
                                   <div class="Rtty"><el-input style="" v-model="Valuea_Kehu.username" disabled placeholder="" ></el-input>  </div>
                                  
                            </div>
                        </div>
                        <div style="width:50%;float:left">
                            <div class="Rig_D">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span>性别：</div>
                                <el-select v-model="Valuea_Kehu.sex_text" placeholder="" disabled @change="changeRTY">
                                    <el-option v-for="item in SEX" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div style="overflow:hidden">
                        <div style="width:50%;float:left">
                            <div class="Rig_D">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 联系方式：</div>
                                <div class="Rtty">
                                <el-input v-model="Valuea_Kehu.mobile" placeholder="" disabled class="El_ii"></el-input>
                                </div>
                            </div>
                        </div>

                        <div style="width:50%;float:left">
                            <div class="Rig_D">
                                <div class="Rig_Ddd" >微信号（选填）：</div>
                                <div class="Rtty">
                                <el-input v-model="Valuea_Kehu.weixin" placeholder="" disabled class="El_ii"></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="overflow:hidden">
                        <div style="width:50%;float:left">
                            <div class="Rig_D">
                                <div class="Rig_Ddd" >工作单位（选填）：</div>
                                <div class="Rtty">
                                <el-input v-model="Valuea_Kehu.company" placeholder="" disabled class="El_ii"></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="margin:25px 0 20px 0;font-weight: bold;font-size:14px">来源信息</div>
                    <div style="overflow:hidden">
                        <div style="width:50%;float:left">
                            <div class="Rig_D">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 客户来源：</div>
                                <el-select v-model="Valuea_Kehu.source_id" placeholder="" disabled>
                                  <el-option v-for="item in leads_source" :key="item.value" :label="item.content" :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                        
                        <div style="width:50%;float:left">
                            <div class="Rig_D ">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 客户价值：</div>
                                <el-select v-model="Valuea_Kehu.worth_id" placeholder="" disabled>
                                    <el-option v-for="item in leads_worth" :key="item.value" :label="item.content" :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div style="overflow:hidden">
                        <div style="width:50%;float:left">
                            <div class="Rig_D">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 办理时间（选填）：</div>
                                <el-date-picker v-model="Valuea_Kehu.expect_time" type="month" placeholder="" disabled ></el-date-picker>
                            </div>
                        </div>
                        
                        <div style="width:50%;float:left">
                            <div class="Rig_D ">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 服务对象：</div> 
                                <el-select v-model="Valuea_Kehu.service_id" placeholder="" disabled>
                                    <el-option v-for="item in leads_worth" :key="item.value" :label="item.content" :value="item.value"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>

                    <div class="Rig_D " style="width:95%">
                      <div class="Rig_Ddd" >客户标签：</div>
                      <div class="Rtty" style="clear:both">
                        <el-select v-model="valueA_sele1" multiple placeholder="" disabled @change="changeRTY">
                            <el-option v-for="item in leads_demand" :key="item.value" :label="item.content" :value="item.value"></el-option>
                        </el-select>  
                      </div>
                    </div> 
                    <div class="Rig_D " style="width:95%">
                      <div class="Rig_Ddd" >需求项目：</div>
                      <div class="Rtty" style="clear:both">
                        <el-select v-model="valueA_sele2" multiple disabled @change="changeRTY">
                            <el-option v-for="item in leads_demand" :key="item.value" :label="item.content" :value="item.value"></el-option>
                        </el-select>
                      </div>
                    </div> 

                    <div class="Rig_D" style="width:98%">
                        <div class="Rig_Ddd" >描述：</div>
                        <div class="Rtty">
                            <el-input type="textarea" v-model="Valuea_Kehu.description" disabled style="width: 97%;"></el-input>           
                        </div>
                    </div>
                    <div>
                      <div class="Rig_Ddd" >图片线索</div>
                      <div class="Rtty" style="clear:both">
                        <img class="Rtt_im22g" v-for="item in full_avatar" :key="item" :label="item" :value="item" :src="item"   />
                      </div>
                    </div>
                    <div class="BCSZ" style="background:#fff;color:#595959;border: 1px solid #D9D9D9;margin-right:30px" @click="show1 = false">取消</div>
                </div>
                <div class="Rig_A" v-if="info_Show == 2">
                    <div style="margin:8px 0 15px 0;font-size: 15px;color: #333333;font-weight: bold;">买家信息</div>
                    <div style="overflow:hidden">
                        <div style="width:33%;float:left">
                            <div class="Rig_D Ruuia">
                                <div class="Rig_Ddd" style="margin-bottom: 14px;"> 
                                  <span style="color:#FF4D4F">* </span>买家姓名（匹配确认）：</div>
                                <div class="Rtty " v-if="chakan111 == 1">
                                    <el-select
                                      style="width:100%"
                                      v-model="valueA_Mai1"
                                      filterable 
                                      remote
                                      reserve-keyword
                                      @focus="tt"
                                      placeholder="请选择买家姓名"
                                      :remote-method="remoteMethod"
                                      @change="Chanssa">
                                      <el-option
                                        v-for="item in options4"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                      </el-option>
                                    </el-select>
                                </div>
                                <div class="Rtty " v-if="chakan111 == 0">
                                    <el-select
                                      style="width:100%"
                                      v-model="valueA_Mai1"
                                      filterable
                                      remote
                                      disabled
                                      reserve-keyword
                                      @focus="tt"
                                      placeholder="请选择买家姓名"
                                      :remote-method="remoteMethod"
                                      @change="Chanssa">
                                      <el-option
                                        v-for="item in options4"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                      </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                        <div style="width:33%;float:left">
                            <div class="Rig_D Ruuia">
                                <div class="Rig_Ddd" style="width:240px;"><span style="color:#FF4D4F">* </span> 买家联系方式（匹配确认）：</div>
                                <div class="Rtty ">
                                <el-input v-model="valueA_Mai2" placeholder="请输入联系方式" disabled class="El_ii"></el-input>
                                </div>
                            </div>
                        </div>
                        <div style="width:33%;float:left">
                            <div class="Rig_D Ruuia3">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 买家来源（匹配确认）：</div>
                                <div class="Rtty ">
                                <el-input v-model="valueA_Mai3" placeholder="请输入买家来源" disabled class="El_ii"></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="margin:8px 0 15px 0;font-size: 15px;color: #333333;font-weight: bold;">服务对象信息</div>
                    <div style="overflow:hidden" v-for="(item, index) in person" :key="item">
                        <div style="width:24.8%;float:left">
                            <div class="Rig_D Ruuit">
                                <div class="Rig_Ddd" style="margin-bottom: 8px;"><span style="color:#FF4D4F">* </span> 服务对象（{{index + 1}}）：</div>
                                <div class="Rtty ">
                                  <el-input v-model="item.username" placeholder="服务对象名称（必填）" class="El_ii"></el-input>
                                </div>
                            </div>
                        </div>
                        <div style="width:24.8%;float:left">
                            <div class="Rig_D Ruuit">
                                <div class="Rig_Ddd" > &nbsp;</div>
                                <div class="Rtty ">
                                  <el-input v-model="item.mobile" placeholder="手机号（必填）" class="El_ii"></el-input>
                                </div>
                            </div>
                        </div>
                        <div style="width:24.8%;float:left">
                            <div class="Rig_D Ruuit">
                                 <div class="Rig_Ddd" >  &nbsp;</div>
                                <div class="Rtty ">
                                  <el-input v-model="item.company" placeholder="工作单位（全称）" class="El_ii"></el-input>
                                </div>
                            </div>
                        </div>
                        <div style="width:24.8%;float:left">
                            <div class="Rig_D Ruuit">
                              <div class="Rig_Ddd" >  &nbsp;</div>
                                <div class="Rtty ">
                                  <el-input v-model="item.id_card" placeholder="有效证件号" class="El_ii"></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div @click="Add_fiwu" style="margin:0px 0 20px 0;font-size: 15px;color: #1890FF;cursor: pointer;">增加服务对象</div>
                    <div style="margin:8px 0 15px 0;font-size: 15px;color: #333333;font-weight: bold;">订单信息</div>
                    <div style="overflow:hidden">
                        <div style="width:33%;float:left">
                            <div class="Rig_D Ruuia">
                                <div class="Rig_Ddd" style="width:240px"> 
                                  <span style="color:#FF4D4F">* </span>订单号（系统自动生成）：</div>
                                <div class="Rtty ">
                                  <el-input v-model="valueA_Din1" disabled class="El_ii" v-if="TextMoMo('order:order:orderno')"></el-input>
                                  <el-input disabled class="El_ii" v-if="!TextMoMo('order:order:orderno')"></el-input>
                                </div>
                            </div>
                        </div>
                        <div style="width:33%;float:left">
                            <div class="Rig_D Ruuia3">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 购买项目：</div>
                                <div class="Rtty ">
                                    <el-select
                                      style="width:100%"
                                      v-model="valueA_Din2"
                                      filterable
                                      remote
                                      reserve-keyword
                                      @focus="tt2"
                                      placeholder="请选择购买项目"
                                      :remote-method="remoteMethod2">
                                      <el-option
                                        v-for="item in options2"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                      </el-option>
                                    </el-select>
                                </div>
                            </div>
                        </div>
                        <div style="width:33%;float:left">
                            <div class="Rig_D Ruuia3">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 服务商（员工）：</div>
                                <el-select v-model="valueA_Din3" placeholder="请选择销售人员是谁">
                                  <el-option v-for="item in BusinessList" :key="item.id" :label="item.username" :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div style="overflow:hidden">
                        <div style="width:33%;float:left">
                            <div class="Rig_D Ruuia">
                                <div class="Rig_Ddd" > 
                                  <span style="color:#FF4D4F">* </span>商品单价：</div>
                                <div class="Rtty ">
                                  <el-input v-model="valueA_Din5" placeholder="请填写商品单价" class="El_ii"></el-input>
                                </div>
                            </div>
                        </div>
                        <div style="width:33%;float:left">
                            <div class="Rig_D Ruuia3">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 商品数量：</div>
                                <div class="Rtty ">
                                  <el-input v-model="valueA_Din4" placeholder="请填写商品数量" class="El_ii"></el-input>
                                </div>
                            </div>
                        </div>
                        <div style="width:33%;float:left">
                            <div class="Rig_D Ruuia3">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 商品应收总金额：</div>
                                <div class="Rtty ">
                                  <el-input v-model="valueA_Din6" placeholder="请输入订单总价" class="El_ii"></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="overflow:hidden">
                        <div style="width:33%;float:left">
                            <div class="Rig_D Ruuia3">
                                <div class="Rig_Ddd" > 
                                  <span style="color:#FF4D4F">* </span>站点：</div>
                                <el-select v-model="valueA_Din7" placeholder="请选择订单属于哪个站点">
                                  <el-option v-for="item in SiteList" :key="item.site_id" :label="item.name" :value="item.site_id"></el-option>
                                </el-select>
                            </div>
                        </div>                      
                    </div>
                    <div style="margin:8px 0 15px 0;font-size: 15px;color: #333333;font-weight: bold;">付款信息</div>
                    <div style="overflow:hidden">
                        <div style="width:33%;float:left">
                            <div class="Rig_D Ruuia3">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 付款形式：</div>
                                <el-select v-model="valueA_Info1" placeholder="请选择付款形式">
                                  <el-option v-for="item in pay_form" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div style="width:33%;float:left">
                            <div class="Rig_D Ruuia3">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 优惠金额：</div>
                                <div class="Rtty ">
                                  <el-input v-model="valueA_Info2" placeholder="请填写优惠金额" class="El_ii"></el-input>
                                </div>
                            </div>
                        </div>
                        <div style="width:33%;float:left">
                            <div class="Rig_D Ruuia3">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 实际支付金额：</div>
                                <div class="Rtty ">
                                  <el-input v-model="valueA_Info3" placeholder="请填写实际支付金额" class="El_ii"></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="overflow:hidden">
                        <div style="width:33%;float:left">
                            <div class="Rig_D Ruuia">
                                <div class="Rig_Ddd" > 
                                  <span style="color:#FF4D4F">* </span>剩余金额：</div>
                                <div class="Rtty ">
                                  <el-input v-model="valueA_Info4" placeholder="请填写剩余金额" class="El_ii"></el-input>
                                </div>
                            </div>
                        </div>
                        <div style="width:33%;float:left">
                            <div class="Rig_D Ruuia3">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 付款时间：</div>
                                <el-date-picker v-model="valueA_Info5" type="date" placeholder="选择月份" ></el-date-picker>
                            </div>
                        </div>
                        <div style="width:33%;float:left">
                            <div class="Rig_D Ruuia3">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 支付方式：</div>
                               <el-select v-model="valueA_Info6" placeholder="请选择支付方式">
                                  <el-option v-for="(item,i) in Pay_method" :key="i" :label="item" :value="i"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div style="margin:8px 0 15px 0;font-size: 15px;color: #333333;font-weight: bold;">尾款信息</div>
                    <div style="overflow:hidden">
                        <div style="width:33%;float:left">
                            <div class="Rig_D Ruuia3">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 尾款应付时间：</div>
                                <el-date-picker v-model="valueA_Wei1" type="date" placeholder="选择尾款应付时间" ></el-date-picker>
                            </div>
                        </div>
                        <div style="width:33%;float:left">
                            <div class="Rig_D Ruuia3">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 尾款付款时间：</div>
                                <el-date-picker v-model="valueA_Wei2" type="date" placeholder="选择尾款付款时间" ></el-date-picker>
                            </div>
                        </div>
                        <div style="width:33%;float:left">
                            <div class="Rig_D Ruuia3">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 支付方式：</div>
                               <el-select v-model="valueA_Wei3" placeholder="请选择支付方式">
                                 <el-option v-for="(item,i) in Pay_method" :key="i" :label="item" :value="i"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </div>
                    <div style="overflow:hidden">
                        <div style="width:33%;float:left">
                            <div class="Rig_D Ruuia">
                                <div class="Rig_Ddd" > 
                                  <span style="color:#FF4D4F">* </span>应付金额：</div>
                                <div class="Rtty ">
                                  <el-input v-model="valueA_Wei4" placeholder="请填写剩余金额" class="El_ii"></el-input>
                                </div>
                            </div>
                        </div>
                        <div style="width:33%;float:left">
                            <div class="Rig_D Ruuia3">
                                <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 实际支付金额：</div>
                                <div class="Rtty ">
                                  <el-input v-model="valueA_Wei5" placeholder="请填写实际支付金额" class="El_ii"></el-input>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="margin:8px 0 15px 0;font-size: 15px;color: #333333;font-weight: bold;">附件</div>
                    <div class="Rig_D" style="width: 100%;">
                        <div class="Rig_Ddd" >订单备注（选填）：</div>
                        <div class="Rtty">
                            <el-input type="textarea" style="" v-model="valueA_Wei6" placeholder="备注信息可以写在这里，方便日后更好的查询与记忆" ></el-input>           
                        </div>
                    </div>
                    <div>
                      <div class="Rig_Ddd" style="margin-bottom:19px"> 合同/付款凭证/重要信息等上传</div>
                      <div class="Rtty" style="clear:both">
                  
                        <img class="Rtt_im22g" v-for="item in full_avatar" :key="item" :label="item" :value="item" :src="item"   />
                        <div style="margin-top:20px">
                          <el-upload
                            :action="upload"
                            :headers="heads"
                            list-type="picture-card"
                            :on-success="UP_Success"
                            :on-remove="HAndemove"
                            :on-preview="handlePictureCardPreview">
                            <i class="el-icon-plus"></i>
                            <div class="el_asff">上传图片</div>
                          </el-upload>
                        </div>
                      </div>
                    </div>
                    <div class="BCSZ" style="margin-right:24px;" @click="Btn_cj(1)" v-if="type_Self == 'self'">保存设置</div>
                    <div class="BCSZ" style="margin-right:24px;" @click="Btn_cj(2)" v-if="type_Self == 'common'">保存设置</div>
                    <div class="BCSZ" style="background:#fff;color:#595959;border: 1px solid #D9D9D9;margin-right:10px" @click="show1 = false">取消</div>
                </div>
                <div v-if="info_Show == 3">
                    <div class="Rig_A">
                      <div class="Rig_D  R_texxt" style="width:95%">
                        <div class="TRRE" v-if="TextMoMo('order:order:showflow')">
                          <div style="margin:8px 0 9px 0;font-size: 14px;color: #333333;">全部进程信息</div>
                          <div style="margin:20px 24px 0 1px;" v-if="Flow_list.length != 0">
                              <el-scrollbar height="100%">
                                <div id="time-line">
                                  <div class="item" v-for="item in Flow_list" :key="item.index">
                                    <div class="ytyt">
                                      <div class="item-index">{{ item.createtime }}</div>
                                      <div class="item-content">{{ item.info }}</div>
                                      <img class="Rtt_im22g" v-for="item in item.imgs_url" :key="item" :label="item" :value="item" :src="item"   />
                                    </div>
                                  </div>
                                </div>
                              </el-scrollbar> 
                          </div>
                        </div>
                        <div class="Rig_D" style="position: relative;width:105%">
                            <div class="Rig_Ddd" style="margin-bottom:11px;margin-top:30px"> <span style="color:#FF4D4F">*</span> 文字记录</div>
                            <div class="Rtty">
                                <el-input type="textarea" style="" v-model="Info_desc" 
                                placeholder="请将每次沟通、维护、跟单、咨询等相关信息记录在这里，为了提高效率
① 选择常用语更新记录
② 手动输入文字信息
③ 将重要的凭证、历史沟通、其他社交媒体截图等在下方上传保存"></el-input>           
                            </div>     
                          <div class="Rtty Riuo fdgfg" style="clear:both;">
                            <div style="margin:4px 23px 0 0;float:right">
                                <el-checkbox v-model="valueA_input1" label="同步给客户"></el-checkbox>
                            </div>
                          </div>
                        </div>  
                        <div>
                          <div class="Rig_Ddd" style="margin:28px 0 9px 0">图片线索（选填）</div>
                          <div class="Rtty TUUu" style="clear:both">
                              <div style="margin-top:20px">
                                <el-upload
                                  :action="upload"
                                  :headers="heads"
                                  list-type="picture-card"
                                  :on-success="UP_Success2"
                                  :on-remove="HAndemove2"
                                  :on-preview="handlePictureCardPreview">
                                  <i class="el-icon-plus"></i>
                                  <div class="el_asff">上传图片</div>
                                </el-upload>
                              </div>
                          </div>
                        </div>

                        <div class="Rtty">
                            <div class="BCSZ" style="margin-right:24px" @click="Btn_dsa" v-if="TextMoMo('order:order:addflow')">保存设置</div>
                            <div class="BCSZ" style="margin-right:24px" v-if="!TextMoMo('order:order:addflow')">保存设置</div>
                            <div class="BCSZ" @click="show1 = false" style="background:#fff;color:#595959;border: 1px solid #D9D9D9;">取  消</div>
                        </div>
                      </div> 

                    </div>
                
                </div>
              </div>
            </el-scrollbar>
          </div>
    </div>
    <!-- 创建线索 -->

    <!-- 创建线索 -->
    <div ref="rightPanel" v-if="show11" class="rightPanel-container show">
          <div class="rightPanel-background"/>
          <div style="height:1100px;width: 822px;position: fixed;top: 0;right: 0;z-index:999;" >
            <el-scrollbar style="height:100%">
              <div class="rightPanel" style="width:822px;max-width: 822px;height: 690px;padding-bottom: 270px;">
                <div class="Rig_1">查看订单<i class="el-icon-close" @click="show11 = false"  style="float:right;padding:20px 50px;cursor: pointer;"></i></div>
                  <div class="Rig_A">
                      <div style="margin:8px 0 15px 0;font-size: 15px;color: #333333;font-weight: bold;">买家信息</div>
                      <div style="overflow:hidden">
                          <div style="width:33%;float:left">
                              <div class="Rig_D Ruuia">
                                  <div class="Rig_Ddd" > 
                                    <span style="color:#FF4D4F">* </span>买家姓名（匹配确认）：</div>
                                  <div class="Rtty ">
                                      <el-select
                                        style="width: 100%;"
                                        v-model="valueA_Mai1"
                                        filterable  disabled
                                        remote
                                        reserve-keyword
                                        @focus="tt"
                                        placeholder="请选择买家姓名"
                                        :remote-method="remoteMethod"
                                        @change="Chanssa">
                                        <el-option
                                          v-for="item in options4"
                                          :key="item.value"
                                          :label="item.label"
                                          :value="item.value">
                                        </el-option>
                                      </el-select>
                                  </div>
                              </div>
                          </div>
                          <div style="width:33%;float:left">
                              <div class="Rig_D Ruuia">
                                  <div class="Rig_Ddd" style="width:240px"><span style="color:#FF4D4F">* </span> 买家联系方式（匹配确认）：</div>
                                  <div class="Rtty ">
                                  <el-input v-model="valueA_Mai2" placeholder="请输入联系方式" disabled class="El_ii"></el-input>
                                  </div>
                              </div>
                          </div>
                          <div style="width:33%;float:left">
                              <div class="Rig_D Ruuia3">
                                  <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 买家来源（匹配确认）：</div>
                                  <div class="Rtty ">
                                  <el-input v-model="valueA_Mai3" placeholder="请输入买家来源" disabled class="El_ii"></el-input>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div style="margin:8px 0 15px 0;font-size: 15px;color: #333333;font-weight: bold;">服务对象信息</div>
                      <div style="overflow:hidden" v-for="(item, index) in person" :key="item">
                          <div style="width:24.8%;float:left">
                              <div class="Rig_D Ruuit">
                                  <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 服务对象（{{index + 1}}）：</div>
                                  <div class="Rtty ">
                                    <el-input v-model="item.username" placeholder="服务对象名称（必填）" disabled class="El_ii"></el-input>
                                  </div>
                              </div>
                          </div>
                          <div style="width:24.8%;float:left">
                              <div class="Rig_D Ruuit">
                                  <div class="Rig_Ddd" > &nbsp;</div>
                                  <div class="Rtty ">
                                    <el-input v-model="item.mobile" placeholder="手机号（必填）" disabled class="El_ii"></el-input>
                                  </div>
                              </div>
                          </div>
                          <div style="width:24.8%;float:left">
                              <div class="Rig_D Ruuit">
                                  <div class="Rig_Ddd" >  &nbsp;</div>
                                  <div class="Rtty ">
                                    <el-input v-model="item.company" placeholder="工作单位（全称）" disabled class="El_ii"></el-input>
                                  </div>
                              </div>
                          </div>
                          <div style="width:24.8%;float:left">
                              <div class="Rig_D Ruuit">
                                <div class="Rig_Ddd" >  &nbsp;</div>
                                  <div class="Rtty ">
                                    <el-input v-model="item.id_card" placeholder="有效证件号" disabled class="El_ii"></el-input>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div @click="Add_fiwu" style="margin:0px 0 20px 0;font-size: 15px;color: #1890FF;cursor: pointer;">增加服务对象</div>
                      <div style="margin:8px 0 15px 0;font-size: 15px;color: #333333;font-weight: bold;">订单信息</div>
                      <div style="overflow:hidden">
                          <div style="width:33%;float:left">
                              <div class="Rig_D Ruuia">
                                  <div class="Rig_Ddd" style="width:240px"> 
                                    <span style="color:#FF4D4F">* </span>订单号（系统自动生成）：</div>
                                  <div class="Rtty ">
                                    <el-input v-model="valueA_Din1" disabled class="El_ii" v-if="TextMoMo('order:order:orderno')"></el-input>
                                    <el-input disabled class="El_ii" v-if="!TextMoMo('order:order:orderno')"></el-input>
                                  </div>
                              </div>
                          </div>
                          <div style="width:33%;float:left">
                              <div class="Rig_D Ruuia3">
                                  <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 购买项目：</div>
                                  <div class="Rtty ">
                                      <el-select
                                        style="width: 100%;"
                                        v-model="valueA_Din2"
                                        filterable
                                        remote
                                        reserve-keyword
                                        @focus="tt2" disabled
                                        placeholder="请选择购买项目"
                                        :remote-method="remoteMethod2">
                                        <el-option
                                          v-for="item in options2"
                                          :key="item.value"
                                          :label="item.label"
                                          :value="item.value">
                                        </el-option>
                                      </el-select>
                                  </div>
                              </div>
                          </div>
                          <div style="width:33%;float:left">
                              <div class="Rig_D Ruuia3">
                                  <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 服务商（员工）：</div>
                                  <el-select v-model="valueA_Din3" placeholder="请选择销售人员是谁" disabled>
                                    <el-option v-for="item in BusinessList" :key="item.id" :label="item.username" :value="item.id"></el-option>
                                  </el-select>
                              </div>
                          </div>
                      </div>
                      <div style="overflow:hidden">
                          <div style="width:33%;float:left">
                              <div class="Rig_D Ruuia">
                                  <div class="Rig_Ddd" > 
                                    <span style="color:#FF4D4F">* </span>商品单价：</div>
                                  <div class="Rtty ">
                                    <el-input v-model="valueA_Din5" placeholder="请填写商品单价" disabled class="El_ii"></el-input>
                                  </div>
                              </div>
                          </div>
                          <div style="width:33%;float:left">
                              <div class="Rig_D Ruuia3">
                                  <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 商品数量：</div>
                                  <div class="Rtty ">
                                    <el-input v-model="valueA_Din4" placeholder="请填写商品数量" disabled class="El_ii"></el-input>
                                  </div>
                              </div>
                          </div>
                          <div style="width:33%;float:left">
                              <div class="Rig_D Ruuia3">
                                  <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 商品应收总金额：</div>
                                  <div class="Rtty ">
                                    <el-input v-model="valueA_Din6" placeholder="请输入订单总价" disabled class="El_ii"></el-input>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div style="overflow:hidden">
                          <div style="width:33%;float:left">
                              <div class="Rig_D Ruuia3">
                                  <div class="Rig_Ddd" > 
                                    <span style="color:#FF4D4F">* </span>站点：</div>
                                  <el-select v-model="valueA_Din7" placeholder="请选择订单属于哪个站点" disabled>
                                    <el-option v-for="item in SiteList" :key="item.site_id" :label="item.name" :value="item.site_id"></el-option>
                                  </el-select>
                              </div>
                          </div>                      
                      </div>
                      <div style="margin:8px 0 15px 0;font-size: 15px;color: #333333;font-weight: bold;">付款信息</div>
                      <div style="overflow:hidden">
                          <div style="width:33%;float:left">
                              <div class="Rig_D Ruuia3">
                                  <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 付款形式：</div>
                                  <el-select v-model="valueA_Info1" placeholder="请选择付款形式" disabled>
                                    <el-option v-for="item in pay_form" :key="item.id" :label="item.name" :value="item.id"></el-option>
                                  </el-select>
                              </div>
                          </div>
                          <div style="width:33%;float:left">
                              <div class="Rig_D Ruuia3">
                                  <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 优惠金额：</div>
                                  <div class="Rtty ">
                                    <el-input v-model="valueA_Info2" placeholder="请填写优惠金额" disabled class="El_ii"></el-input>
                                  </div>
                              </div>
                          </div>
                          <div style="width:33%;float:left">
                              <div class="Rig_D Ruuia3">
                                  <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 实际支付金额：</div>
                                  <div class="Rtty ">
                                    <el-input v-model="valueA_Info3" placeholder="请填写实际支付金额" disabled class="El_ii"></el-input>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div style="overflow:hidden">
                          <div style="width:33%;float:left">
                              <div class="Rig_D Ruuia">
                                  <div class="Rig_Ddd" > 
                                    <span style="color:#FF4D4F">* </span>剩余金额：</div>
                                  <div class="Rtty ">
                                    <el-input v-model="valueA_Info4" placeholder="请填写剩余金额" disabled class="El_ii"></el-input>
                                  </div>
                              </div>
                          </div>
                          <div style="width:33%;float:left">
                              <div class="Rig_D Ruuia3">
                                  <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 付款时间：</div>
                                  <el-date-picker v-model="valueA_Info5" type="date" placeholder="选择月份" disabled ></el-date-picker>
                              </div>
                          </div>
                          <div style="width:33%;float:left">
                              <div class="Rig_D Ruuia3">
                                  <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 支付方式：</div>
                                <el-select v-model="valueA_Info6" placeholder="请选择支付方式" disabled>
                                    <el-option v-for="(item,i) in Pay_method" :key="i" :label="item" :value="i"></el-option>
                                  </el-select>
                              </div>
                          </div>
                      </div>
                      <div style="margin:8px 0 15px 0;font-size: 15px;color: #333333;font-weight: bold;">尾款信息</div>
                      <div style="overflow:hidden">
                          <div style="width:33%;float:left">
                              <div class="Rig_D Ruuia3">
                                  <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 尾款应付时间：</div>
                                  <el-date-picker v-model="valueA_Wei1" type="date" placeholder="选择尾款应付时间" disabled ></el-date-picker>
                              </div>
                          </div>
                          <div style="width:33%;float:left">
                              <div class="Rig_D Ruuia3">
                                  <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 尾款付款时间：</div>
                                  <el-date-picker v-model="valueA_Wei2" type="date" placeholder="选择尾款付款时间" disabled ></el-date-picker>
                              </div>
                          </div>
                          <div style="width:33%;float:left">
                              <div class="Rig_D Ruuia3">
                                  <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 支付方式：</div>
                                <el-select v-model="valueA_Wei3" placeholder="请选择支付方式" disabled>
                                  <el-option v-for="(item,i) in Pay_method" :key="i" :label="item" :value="i"></el-option>
                                  </el-select>
                              </div>
                          </div>
                      </div>
                      <div style="overflow:hidden">
                          <div style="width:33%;float:left">
                              <div class="Rig_D Ruuia">
                                  <div class="Rig_Ddd" > 
                                    <span style="color:#FF4D4F">* </span>应付金额：</div>
                                  <div class="Rtty ">
                                    <el-input v-model="valueA_Wei4" placeholder="请填写剩余金额" class="El_ii" disabled></el-input>
                                  </div>
                              </div>
                          </div>
                          <div style="width:33%;float:left">
                              <div class="Rig_D Ruuia3">
                                  <div class="Rig_Ddd" ><span style="color:#FF4D4F">* </span> 实际支付金额：</div>
                                  <div class="Rtty ">
                                    <el-input v-model="valueA_Wei5" placeholder="请填写实际支付金额" class="El_ii" disabled></el-input>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div style="margin:8px 0 15px 0;font-size: 15px;color: #333333;font-weight: bold;">附件</div>
                      <div class="Rig_D" style="width: 100%;">
                          <div class="Rig_Ddd" >订单备注（选填）：</div>
                          <div class="Rtty">
                              <el-input type="textarea" style="" v-model="valueA_Wei6" placeholder="备注信息可以写在这里，方便日后更好的查询与记忆" disabled></el-input>           
                          </div>
                      </div>
                      <div>
                        <div class="Rig_Ddd" style="margin-bottom:19px"> 合同/付款凭证/重要信息等上传</div>
                        <div class="Rtty" style="clear:both">
                          <img class="Rtt_im22g" v-for="item in full_avatar" :key="item" :label="item" :value="item" :src="item"   />
                        </div>
                      </div>
                      <div class="BCSZ" style="background:#fff;color:#595959;border: 1px solid #D9D9D9;margin-right:10px" @click="show11 = false">取消</div>
                  </div>
              </div>
            </el-scrollbar>
          </div>
    </div>
    <!-- 创建线索 -->
  </div>
</template>

<script>
import axios from 'axios'
import  TextMoth  from "../../components/utils.vue";
import { fetchData } from "../../api/index";
export default { 
  name: "basetable",
  data() {
    return {
      Customer_id:0,
      tableData1: [],
      tableData2: [],
      TA_name1:'',
      TA_name11:'',
      TA_name111:'',
      TA_name1_Arr:[],
      TA_name2:'订单管理',
      TA_name22:'',
      TA_name222:'',
      TA_name333:'',
      TA_name3:'',
      Show:false,
      Inpup:'',
      reverse: true,
      Flow_list:[],
      
      info_Show:0 ,
      checked_kehu:false,
      activeIndex: '3',
      acndex:'1',
      dialogImageUrl: '',
      radio:'1',

      show1:false,
      show11:false,
      editVisible_DEX:false,
      dialogVisible2: false,  
      dialogVisible3: false,  
      dialogVisible4: false,
      multipleSelection_id:null,   //勾选的信息
      multipleSelection:[],
      Ta_Shsh:0,

      tableData: [],
      total1:0,
      total2:0,
      currentPage1:0,
      currentPage2:0,

      idW:0,
      idY:0,
      idG:0,

      Categ:[],
      Categ2:[],
      input_seach:'',
      type_Self: 'self',
      dialogVisible3_e:0,
      dialogVisible2_e:0,

      Config1:[],
      Config2:[],
      Config3:[],
      Config4:[],
      Config5:[],
      Config6:[],
      leads_source:[],  //线索来源
      leads_source_W:[],  //线索来源
      leads_source_id:0,  //线索来源
      leads_source_value:0,

      leads_demand:[],  //线索需求
      leads_demand_W:[],  //线索需求
      leads_demand_id:0,  //线索需求
      leads_demand_value:0,  //线索需求

      leads_worth:[],  //线索价值
      leads_worth_W:[],  //线索价值
      leads_worth_id:0,  //线索价值
      leads_worth_value:0,  //线索价值

      Months1:'',
      Months2:'',
      Months3:'',
      Months4:'',

      se_id:0,
      wo_id:0,
      de_id:0,

      te_id: '',                     //站点
      sa_id: '',                     //服务商
      st_id: '',                     //支付状态，10=未支付,20=已支付
      co_id: '',                     //接单状态
      ba_id: '',                     //退款状态，10=未退款,20=退款中,30=已退款
      pa_id: '',                     //付款形式



      Case_attse:[],  //可见部门
      chakan111:0,
      Hand_id:0,
      Customer_id:0,

      SiteList:[],      //站点列表
      person:[{mobile:'',username:'',company:'',id_card:''}],        //服务对象
      pay_form:[{id:'10',name:'全款'},{part:'20',name:'部分'}],
      radio1:'天',

      valueA_Mai1:'',
      valueA_Mai2:'',
      valueA_Mai3:'',

      valueA_Din1:'',
      valueA_Din2:'',
      valueA_Din3:'',
      valueA_Din4:'',
      valueA_Din5:'',
      valueA_Din6:'',
      valueA_Din7:'',

      valueA_Info1:'',
      valueA_Info2:'',
      valueA_Info3:'',
      valueA_Info4:'',
      valueA_Info5:'',
      valueA_Info6:'',

      valueA_Wei1:'',
      valueA_Wei2:'',
      valueA_Wei3:'',
      valueA_Wei4:'',
      valueA_Wei5:'',
      valueA_Wei6:'',

      Valuea_Kehu:{},
      Valuea_Xiansuo:{},
      valueA_3:'',
      valueA_sele1:'',
      valueA_sele2:'',

      Row_Eurl:[],          //图片
      Row_Eurl2:[],          //图片
      Info_desc:'',
      Claim:{},

      File:'',
      File_Yid:[],
      File_Bid:[],
      fileList:[],

      upload:'https://rest-api.duxin365.com/admin/ajax/upload',
      upload2:'https://rest-api.duxin365.com/admin/ajax/upload',
      heads:{token:''},

      MMD:[{id:'self',name:'我的订单'},{id:'common',name:'全部订单'}],
      MMD_detail:{},
      editVisible:false,
      editVisible2:false,
      editVisible3:false,
      Customer_worth:[],
      Customer_Self:'',
      StaFFList:[],    ///////////// 全部员工列表
      DementList:[],   ///////////// 全部部门列表

      fForm:{},
      Fwus_list:[],
      BusinessList:[],
      OPzt:[],
      OPzt2:[],
      OPzt3:[],
      OPzt4:[],

      Order_status:{},
      Invoice:{},

      Pay_type:{},
      Pay_method:{},

      list: [],
      list2:[],
      options : [],
      value : [],
      loading : false,

      States:[],

      options4:null,
      options2:null,
      value:null,
    };
  },
  mounted() {
    console.log(this.$route.params.id)
    var that = this

    if(that.$route.params.id != undefined) {
        axios.get('/admin/order/order/info',{
          params:{
              customer_id: that.$route.params.id
            }
          }).then(function (res) {
            if (res.data.code == 0) {
              alert('请求失败');  
            } else { 
              that.valueA_Din1 = res.data.data.order_no
              that.valueA_Mai1 = res.data.data.customer.username //客户姓名
              that.valueA_Mai2 = res.data.data.customer.mobile //手机号
              that.valueA_Mai3 = res.data.data.customer.source  //买家来源
            }
          }) 
          setTimeout(function() {
            that.show1 = true
            that.chakan111 = 1
            that.info_Show = 2
            that.acndex = 3
            that.$route.query = null
          },100)
    }
    let token = window.localStorage.getItem("accessToken")
    that.heads.token = token
    axios.get('/admin/order/order/statisticsColumns',{   //        获取统计列表
        }).then(function (res) {
          if (res.data.code == 0) {
            alert('请求失败');  
          } else{ 
              that.Order_status = res.data.data.order_status
              that.OPzt = res.data.data.pay_status
              that.Invoice = res.data.data.invoice
              that.OPzt2 = res.data.data.is_confirm
              that.OPzt3 = res.data.data.back_status
              that.Pay_type = res.data.data.pay_type
              that.OPzt4 = res.data.data.pay_form
              that.Pay_method = res.data.data.pay_method
          }
    })  
    axios({ method: 'post', url: '/admin/ajax/goodsList', 
        }).then(function (res) {
          if(res.data.code == 0) {
          } else {
            that.leads_source = res.data.data
            for (var i = 0; i < res.data.data.length; i++) {
              let obj = {}
              obj.value = res.data.data[i].goods_name 
              obj.labe = res.data.data[i].goods_id
              that.list2.push(obj)
            }
          }
    })
    axios({
          method: 'post',
          url: '/admin/ajax/customerList', 
          data: {
            keyword:''
          },
        }).then(function (res) {
          if(res.data.code == 0) {
          } else {
            that.States = res.data.data
            console.log(res.data.data)
            for (var i = 0; i < res.data.data.length; i++) {
              let obj = {}
              obj.value = res.data.data[i].username 
              obj.labe = res.data.data[i].id
              that.list.push(obj)
            }
          }
    })
    axios.get('/admin/ajax/staffList',{   // 全部员工列表
        }).then(function (res) {
          if (res.data.code == 0) {
            alert('请求失败');  
          } else{ 
              that.StaFFList = res.data.data
              console.log(that.StaFFList)
          }
    })  
    axios.get('/admin/company/department/index',{   // 全部部门列表
      }).then(function (res) {
        if (res.data.code == 0) {
          alert('请求失败');  
        } else{ 
          that.DementList = res.data.data.rows
        }
    })
    axios.get('/admin/ajax/allBusiness',{   // 服务商列表
      }).then(function (res) {
        if (res.data.code == 0) {
          alert('请求失败');  
        } else{ 
          that.Fwus_list = res.data.data
          console.log(that.Fwus_list)
        }
    })
    axios.get('/admin/ajax/businessList',{   // 服务商
      }).then(function (res) {
        if (res.data.code == 0) {
          alert('请求失败');  
        } else{ 
          that.BusinessList = res.data.data
        }
    })

    that.AAAAA()

    axios.get('/admin/ajax/siteList',{   // 站点列表    
      }).then(function (res) {
        if (res.data.code == 0) {
          alert('请求失败');  
        } else{ 
          that.SiteList = res.data.data
          console.log(that.SiteList)
        }
    })     
  },
  methods: {
    TextMoMo(e) {
      var arr = TextMoth.getData(e)
      return arr  
    },
    handleRowClick(row, column, event){
      this.$refs.multipleTable.toggleRowSelection(row);
    },
    Chanssa(e) {
      var that = this
      var arr = that.States
      console.log(arr)
      for (let i = 0; i < arr.length; i++) {
        const element = arr[i];
        if (element.username == e) {
          that.valueA_Mai2 = element.mobile
          that.valueA_Mai3 = element.source
          that.Customer_id = element.id
        }
      }
      console.log(e)
      // 
    },
    tt () {
      this.options4 = this.list
      console.log(this.options4)
    },
    tt2 () {
      this.options2 = this.list2
      console.log(this.options4)
    },

    remoteMethod (query) {
      console.log(query)
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.options4 = this.list.filter(item => {
            return item.value.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
          console.log(this.options4)
        }, 200)
      } else {
        this.options4 = []
      }
    },
    remoteMethod2 (query) {
      console.log(query)
      if (query !== '') {
        this.loading = true
        setTimeout(() => {
          this.loading = false
          this.options2 = this.list2.filter(item => {
            return item.value.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
          console.log(this.options2)
        }, 200)
      } else {
        this.options2 = []
      }
    },
    Add_fiwu(e) {
      var that= this
      var arr = that.person
      if (arr == undefined) {
        var arr  = []
      }
      var att = {
          mobile:'',username:'',company:'',id_card:''
      }
      arr.push(att)
      console.log(arr)
      that.person = arr
    },
    Btn_cj(e) {         // 
      var that = this
      var a1 = that.formatDate(that.valueA_Wei1)
      var a2 = that.formatDate(that.valueA_Wei2)

      var Vall = that.valueA_Din2
      var vaa_id = 0
      for (let i = 0; i < that.leads_source.length; i++) {
        const element = that.leads_source[i];
        if (element.goods_name == Vall) {
            vaa_id = element.goods_id
        }
      }
      if (that.chakan111 == 1) {
        axios({
          method: 'post',
          url: '/admin/order/order/add', 
          data: {
            row:{
              username: that.valueA_Mai1, //客户姓名
              mobile: that.valueA_Mai2, //手机号
              source_id: that.valueA_Mai3,  //买家来源

              order_no: that.valueA_Din1, //订单号
              goods_id: vaa_id,    //购买项目
              business_id:that.valueA_Din3,    //服务商id
              customer_id:that.Customer_id,
              goods_price: that.valueA_Din5, //商品单价
              goods_num: that.valueA_Din4, //商品数量
              total_price: that.valueA_Din6,   //总金额
              site_id:that.valueA_Din7,       //站点

              pay_form:that.valueA_Info1,      //付款形式
              discount:that.valueA_Info2,      //优惠金额
              pay_price:that.valueA_Info3,      //实际支付金额
              unpaid_money:that.valueA_Info4,      //剩余金额
              pay_time:that.valueA_Info5,      //付款时间
              pay_type:that.valueA_Info6,      //支付方式
              

              remark: that.valueA_Wei6,   //备注
              images:that.Row_Eurl, //图片凭证
            },
            person: that.person, 
            unpaid:{
              expect_pay_time: a1,  //尾款应付时间
              pay_time: a2,        //尾款付款时间
              pay_method:that.valueA_Wei3,        //尾款支付方式
              payable_money:that.valueA_Wei4,  //尾款应付时间
              pay_money:that.valueA_Wei5,  //尾款应付时间
            },
          },
        }).then(function (res) {
          if (res.data.code == 0) {
            that.$message.warning(res.data.msg);
            console.log('qweqwe')
          }else {
            that.$message.success(res.data.msg);
            that.show1 = false
            that.AAAAA()  
          }
        
        })
      } else if (that.chakan111 == 0) {
        axios({
          method: 'put',
          url: '/admin/order/order/edit', 
          data: {
            id: that.Hand_id,
            row:{
              username: that.valueA_Mai1, //客户姓名
              mobile: that.valueA_Mai2, //手机号
              source_id: that.valueA_Mai3,  //买家来源

              order_no: that.valueA_Din1, //订单号
              goods_id: vaa_id,    //购买项目
              business_id:that.valueA_Din3,    //服务商id
              customer_id:that.Customer_id,
              goods_price: that.valueA_Din5, //商品单价
              goods_num: that.valueA_Din4, //商品数量
              total_price: that.valueA_Din6,   //总金额
              site_id:that.valueA_Din7,       //站点

              pay_form:that.valueA_Info1,      //付款形式
              discount:that.valueA_Info2,      //优惠金额
              pay_price:that.valueA_Info3,      //实际支付金额
              unpaid_money:that.valueA_Info4,      //剩余金额
              pay_time:that.valueA_Info5,      //付款时间
              pay_type:that.valueA_Info6,      //支付方式
              remark: that.valueA_Wei6,   //备注

              images:that.Row_Eurl, //图片凭证

            },
            person: that.person, 
            unpaid:{
              expect_pay_time: a1,  //尾款应付时间
              pay_time: a2,        //尾款付款时间
              pay_method:that.valueA_Wei3,        //尾款支付方式
              payable_money:that.valueA_Wei4,  //尾款应付时间
              pay_money:that.valueA_Wei5,  //尾款应付时间
            },
          },
        }).then(function (res) {
          if (res.data.code == 0) {
            that.$message.warning(res.data.msg);
            console.log('qweqwe')
          }else {
            that.$message.success(res.data.msg);
            that.show1 = false
            that.AAAAA()  
          }
        
        })
      }
       
    },
    export2Excel() {
      require.ensure([], () => {
        const { export_json_to_excel } = require('../../excel/Export2Excel');
        const tHeader = ['买家姓名', '联系方式', '订单号', '购买项目' , '支付金额', '剩余金额', '支付方式', '接单状态'];
        // 上面设置Excel的表格第一行的标题
        const filterVal = ['username', 'mobile', 'order_no', 'goods_name', 'pay_price', 'unpaid_money', 'pay_type_text', 'confirm_status_text'];
        // 上面的index、nickName、name是tableData里对象的属性
        const list = this.tableData;  //把data里的tableData存到list
        const data = this.formatJson(filterVal, list);
        export_json_to_excel(tHeader, data, '销售线索');    
      })
    },

    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },

    beforeUpload(file) {                             // 上传文件之前的钩子：判断上传文件格式、大小等，若返回false则停止上传
        //文件类型
        const isType = file.type === 'application/vnd.ms-excel'
        const isTypeComputer = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        const fileType = isType || isTypeComputer
        if(!fileType) {
            this.$message.error('上传文件只能是xls/xlsx格式！')
        }

        // 文件大小限制为10M
        const fileLimit = file.size / 1024 / 1024 < 10;
        if(!fileLimit) {
            this.$message.error('上传文件大小不超过10M！');
        }
        return fileType && fileLimit
    },
    File_Sure(e) {
      var that = this
      var arr = []
      var acc = []
      axios({
          method: 'post',
          url: '/admin/order/order/import', 
          data: {
            file:that.File,
            power:{
              staff_ids:that.File_Yid,
              department_ids:that.valueA_5
            }
          },
        }).then(function (res) {
          if(res.data.code == 0) {
            that.$message.warning(res.data.msg);
          } else {
              that.$message.success(res.data.msg);
              that.editVisible_DEX = false
          }
        })       
    },

    UP_Success3(e) {                //图片上传成功
      var that = this
      console.log(e)
      that.File = e.data.url
      that.aTY = 0
      console.log(that.File)
    },
    fileRemove(file, fileList) {                    // 移除选择的文件
        if(fileList.length < 1) {
            this.uploadDisabled = true //未选择文件则禁用上传按钮
        }
        console.log(file)
    },
    changeRTY(e) {
      var that = this
      console.log(e)
      console.log(that.valueA_3)
    },
    Handlbchak(e,data) {
      var that = this
      that.Hand_id = data.id
      that.Customer_id = data.customer_id
      that.chakan111 = 0
      if (e == 1) {
        that.show1 = true
        that.info_Show = 2
        that.acndex = 3
      } else if( e== 2 ){
        that.info_Show = 3
        that.acndex = 4
      } else if (e == 3) {
        that.show11 = true
      }
      axios.get('/admin/order/order/read',{   //                      详情
            params:{
              id: data.id
            }
        }).then(function (res) {
          if (res.data.code == 0) {
            alert('请求失败');  
          } else { 
              that.person = res.data.data.person_list
              that.Customer_id = res.data.data.customer ? res.data.data.customer_id : ''   //
              that.valueA_Mai1 = res.data.data.customer ? res.data.data.customer.username : '', //客户姓名
              that.valueA_Mai2 = res.data.data.customer ? res.data.data.customer.mobile : '' , //手机号
              that.valueA_Mai3 = res.data.data.customer ? res.data.data.customer.source : '',  //买家来源

              that.valueA_Din1 = res.data.data.row.order_no, //订单号
              // that.valueA_Din2 = parseInt(res.data.data.row.goodsone.goods_id),    //购买项目
              that.valueA_Din2 = res.data.data.row.goodsone.goods_name,    //购买项目
              console.log(res.data.data.row.goodsone)
              that.valueA_Din3 = res.data.data.row.business_id,    //服务商id
              that.valueA_Din4 = res.data.data.row.goodsone.total_num, //商品数量
              that.valueA_Din5 = res.data.data.row.goodsone.goods_price, //商品单价

              that.valueA_Din6 = res.data.data.row.total_price,   //总金额
              that.valueA_Din7 = res.data.data.row.site_id,       //站点

              that.valueA_Info1 = res.data.data.row.pay_form,      //付款形式
              that.valueA_Info2 = res.data.data.row.discount,      //优惠金额
              that.valueA_Info3 = res.data.data.row.pay_price,      //实际支付金额

              that.valueA_Info5 = res.data.data.row.pay_time_text,      //付款时间
              that.valueA_Info6 = res.data.data.row.pay_method

                if (res.data.data.unpaid == null) {
                  that.valueA_Wei1 = ''
                  that.valueA_Wei2 = ''
                  that.valueA_Wei3 = ''
                  that.valueA_Wei4 = ''
                  that.valueA_Wei5 = ''
                  that.valueA_Wei6 = ''
                  that.valueA_Info4 = ''
                } else {
                    that.valueA_Info4 = res.data.data.unpaid.unpaid_money,      //剩余金额
                    that.valueA_Wei1 = res.data.data.unpaid.expect_pay_time,  //尾款应付时间
                    that.valueA_Wei2 = res.data.data.unpaid.pay_time,        //尾款付款时间
                    that.valueA_Wei3 = res.data.data.unpaid.pay_method,        //尾款支付方式
                    that.valueA_Wei4 = res.data.data.unpaid.pay_money,  //尾款应付时间
                    that.valueA_Wei5 = res.data.data.unpaid.pay_money  //尾款应付时间
                }

              that.valueA_Wei6 = res.data.data.row.remark

              that.full_avatar = res.data.data.row.imgs_url
              that.Row_Eurl = res.data.data.row.images

          }
      })
      axios.get('/admin/order/order/showflow',{   // 线索 进程信息
            params:{
              id: data.id
            }
        }).then(function (res) {
          if (res.data.code == 0) {
            alert('请求失败');  
          } else { 
            that.Flow_list = res.data.data.flowList
          }
      }) 
    },
    //升级
    Handlupgrade(data){
      var that = this
      var arr = []
      arr.push(data.id)
      that.$confirm("确定要升级吗？", "提示", {
        type: "primary"
      }).then(() => {
        axios({
          method: 'post',
          url: '/admin/order/order/upgrade',
          data: {
            ids: arr
          },
        }).then(function (res) {
          that.tableData = res.data.data.rows
          that.total = res.data.data.total
          that.$forceUpdate()
        })
      })
    },
    Close() {
      this.dialogVisible3 = false;
      this.dialogVisible4 = false;
      this.dialogVisible5 = false;
      this.show1 = false;
    },
    TJ2() {
      this.dialogVisible7 = true;
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    Btn_dsa() {                     //  进程提交
      var that = this
      axios({
          method: 'post',
          url: '/admin/order/order/addflow', 
          data: {
            id:that.Hand_id,
            row:{
              info: that.Info_desc, //进程的信息
              images: that.Row_Eurl2
            }
          },
        }).then(function (res) {
          if(res.data.code == 0) {
            that.$message.warning(res.data.msg);
          } else {
              that.$message.success(res.data.msg);
                    axios.get('/admin/order/order/showflow',{   // 线索 进程信息
            params:{
              id: that.Hand_id
            }
        }).then(function (res) {
          if (res.data.code == 0) {
            alert('请求失败');  
          } else { 
            that.Flow_list = res.data.data.flowList
          }
      }) 
          }
          
        })       
    },

    AddXs(e) {                      // 
      var that = this
       that.dialogVisible3_e = e
       let y1 =''
       let y2 =''
       
       if(that.Months1 != '') {
         y1 = that.formatDate(that.Months1);
       }
       if(that.Months2 != '') {
         y2 = that.formatDate(that.Months2);
       }

      if (e == 1) {
        that.dialogVisible3 = true
        that.Categ = that.leads_source_W
      } else if (e == 2) {
        that.dialogVisible3 = true
        that.Categ = that.leads_demand_W
      } else if (e == 3) {
        that.dialogVisible3 = true
        that.Categ = that.leads_worth_W
      } else if (e == 4) {
        // that.dialogVisible3 = true
        axios({
          method: 'post',
          url: '/admin/order/order/index', 
          data: {
            page: 1,
            offset:0,
            limit:10,
            // type: that.type_Self,
            filter:{
              source_id: that.se_id,                        //订单来源id
              goods_id: that.wo_id,                         //销售项目ID
              pay_type: that.de_id,                         //支付方式ID

              site_id: that.te_id,                          // 站点id
              business_id: that.sa_id,                          // 服务商id
              pay_status: that.st_id,                       //支付状态，10=未支付,20=已支付
              is_confirm: that.co_id,                     //接单状态，10=未接单,20=已接单
              back_status: that.ba_id,                     //退款状态，10=未退款,20=退款中,30=已退款
              pay_form: that.pa_id,                     //付款形式，all=全款,part=部分
              time:{
                min:y1,
                max:y2,
              },
              money:{
                min:that.Months3,
                max:that.Months4,
              },
              keyword:that.input_seach
            }
          },
        }).then(function (res) {
          that.tableData = res.data.data.rows
          that.total1 = res.data.data.total
        })
      } else if (e == 5) {
            that.info_Show = 2
            that.acndex = 3
          axios.get('/admin/order/order/info',{
          }).then(function (res) {
            if (res.data.code == 0) {
              alert('请求失败');  
            } else { 
              that.valueA_Din1 = res.data.data.order_no
            }
          }) 
          that.chakan111 = 1
          that.show1 = true
              that.valueA_Mai1 = ''
              that.valueA_Mai2 = ''
              that.valueA_Mai3 = ''
              that.person = [{mobile:'',username:'',company:'',id_card:''}]
              
              that.valueA_Din2 = ''
              that.valueA_Din3 = ''
              that.valueA_Din5 = ''
              that.valueA_Din4 = ''
              that.valueA_Din6 = ''
              that.valueA_Din7 = ''

              that.valueA_Info1 = ''
              that.valueA_Info2 = ''
              that.valueA_Info3 = ''
              that.valueA_Info4 = ''
              that.valueA_Info5 = ''
              that.valueA_Info6 = ''


              that.valueA_Wei1 = ''
              that.valueA_Wei2 = ''
              that.valueA_Wei3 = ''
              that.valueA_Wei4 = ''
              that.valueA_Wei5 = ''

          that.Row_Eurl=[]      
          that.full_avatar=[]      
      } else if (e == 6) {
        axios({
          method: 'post',
          url: '/admin/order/order/index', 
          data: {
            page: 1,
            offset:0,
            limit:10,
            // type: that.type_Self,
            filter:{

              source_id: that.se_id,                        //订单来源id
              goods_id: that.wo_id,                         //销售项目ID
              pay_type: that.de_id,                         //支付方式ID

              site_id: that.te_id,                          // 站点id
              business_id: that.sa_id,                          // 服务商id
              pay_status: that.st_id,                       //支付状态，10=未支付,20=已支付
              is_confirm: that.co_id,                     //接单状态，10=未接单,20=已接单
              back_status: that.ba_id,                     //退款状态，10=未退款,20=退款中,30=已退款
              pay_form: that.pa_id,                     //付款形式，all=全款,part=部分
              time:{
                min:y1,
                max:y2,
              },
              money:{
                min:that.Months3,
                max:that.Months4,
              },
              keyword:that.input_seach
            }
          },
        }).then(function (res) {
          that.tableData = res.data.data.rows
          that.total1 = res.data.data.total
        })   
        // that.BBBBB()
      } else if (e == 10) {
        that.Months1 = ''
        that.Months2 = ''
        that.Months3 = ''
        that.Months4 = ''
        that.te_id = ''              
        that.sa_id = ''                 
        that.st_id = ''              
        that.co_id = ''                
        that.ba_id = ''               
        that.pa_id = ''  
      }
    },
    NNNNN(e){         //内容管理
      var that = this
      that.dialogVisible2 = true
      that.dialogVisible2_e = e
      
      axios.get('/admin/customer/config/statisticsColumns',{   // 设置选项 
            params:{
              type: 'order'
            }
        }).then(function (res) {
          if (res.data.code == 0) {
            alert('请求失败');  
          } else{ 
              that.Claim = res.data.data
              if (e == 1) {
                that.Categ2 = res.data.data.claim_day
                that.Config1 = res.data.data.claim_day
              } else if(e == 2) {
                that.Categ2 = res.data.data.claim_one
                that.Config2 = res.data.data.claim_one
              } else if(e == 3) {
                that.Categ2 = res.data.data.flow_min
                that.Config3 = res.data.data.flow_min
              } else if(e == 4) {
                that.Categ2 = res.data.data.export_week
                that.Config4 = res.data.data.export_week
              } else if(e == 5) {
                that.Categ2 = res.data.data.export_one
                that.Config5 = res.data.data.export_one
              } else if(e == 6) {
                that.Categ2 = res.data.data.claim_num
                that.Config6 = res.data.data.claim_num
              }
          }
      })  

    },
    formatDate(value) {    // 时间戳
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;

        return y + "-" + MM + "-" + d
    },
    Activ(e, id) {
      var that = this
       let y1 =''
       let y2 =''
       if(that.Months1 != '') {
         y1 = that.formatDate(that.Months1);
       }
       if(that.Months2 != '') {
         y2 = that.formatDate(that.Months2);
       }
      if (e == 1) {
        that.leads_source_value = id
        that.se_id = id
      } else if (e == 2) {
        that.leads_demand_value = id
        that.wo_id = id
      } else if (e == 3) {
        that.de_id =id
        that.leads_worth_value = id
      }
      axios({
        method: 'post',
        url: '/admin/order/order/index', 
        data: {
          page: 1,
          offset:0,
          limit:10,
          // type: that.type_Self,
          filter:{
            pay_method: that.de_id,                        //订单来源id
            goods_id: that.wo_id,                         //销售项目ID
            pay_type: that.se_id,                         //支付方式ID

            site_id: that.te_id,                          // 站点id
            business_id: that.sa_id,                          // 服务商id
            pay_status: that.st_id,                       //支付状态，10=未支付,20=已支付
            is_confirm: that.co_id,                     //接单状态，10=未接单,20=已接单
            back_status: that.ba_id,                     //退款状态，10=未退款,20=退款中,30=已退款
            pay_form: that.pa_id,                     //付款形式，all=全款,part=部分
            time:{
              min:y1,
              max:y2,
            },
            money:{
              min:that.Months3,
              max:that.Months4,
            },
            keyword:that.input_seach
          }
        },
      }).then(function (res) {
        that.tableData = res.data.data.rows
        that.total1 = res.data.data.total
      })
    },
    Add_leibie() {            //创建导航类别
      var that = this
      var ATT = that.Categ
      var srt = {
        content: "新加",
        status: 'normal',
        type: "custom",
        value:0,
      }
      ATT.push(srt)
      that.Categ = ATT
    },  
    Add_leibie2() {            //创建导航类别    --------------全部线索管理
      var that = this
      var ATT = that.Categ2
      var srt = {
        content: "10",
        status: 'normal',
        type: "custom",
        value:0,
      }
      ATT.push(srt)
      that.Categ2 = ATT
    }, 
    NabCH_BTN() {             // 导航确认
        var that = this 
        var ATT = that.Categ
        if (that.dialogVisible3_e == 1) {
          axios({
            method: 'post',
            url: '/admin/company/content/edit',
            data: {
              field_key: "order_source", //内容标识
              content: ATT
            },
          }).then(function (res) {
              if (res.data.code == 0) {
                that.$message.warning(res.data.msg);
              } else {
                that.dialogVisible3 = false
                that.Columns()
              }
          })  
        } else if(that.dialogVisible3_e == 2) {
          axios({
            method: 'post',
            url: '/admin/company/content/edit',
            data: {
              field_key: "order_sale_goods", //内容标识
              content: ATT
            },
          }).then(function (res) {
              if (res.data.code == 0) {
                that.$message.warning(res.data.msg);
              } else {
                that.dialogVisible3 = false
                that.Columns()
              }
          })            

        } else if(that.dialogVisible3_e == 3) {
          axios({
            method: 'post',
            url: '/admin/company/content/edit',
            data: {
              field_key: "order_pay_type", //内容标识
              content: ATT
            },
          }).then(function (res) {
              if (res.data.code == 0) {
                that.$message.warning(res.data.msg);
              } else {
                that.dialogVisible3 = false
                that.Columns()
              }
          })  
        }
     
    },
    NabCH_BTN2() {             // 导航确认         --------------全部线索管理
        var that = this 
        var ATT = that.Categ2
        if (that.dialogVisible2_e == 1) {
          axios({
            method: 'post',
            url: '/admin/company/content/edit',
            data: {
              field_key: "leads_claim_day", //内容标识
              content: ATT
            },
          }).then(function (res) {
              if (res.data.code == 0) {
                that.$message.warning(res.data.msg);
              } else {
                that.dialogVisible2 = false
                that.BBBBB()
              }
          })  
        } else if (that.dialogVisible2_e == 2) {
          axios({
            method: 'post',
            url: '/admin/company/content/edit',
            data: {
              field_key: "leads_claim_one", //内容标识
              content: ATT
            },
          }).then(function (res) {
              if (res.data.code == 0) {
                that.$message.warning(res.data.msg);
              } else {
                that.dialogVisible2 = false
                that.BBBBB()
              }
          })  
        } else if (that.dialogVisible2_e == 3) {
          axios({
            method: 'post',
            url: '/admin/company/content/edit',
            data: {
              field_key: "leads_flow_min", //内容标识
              content: ATT
            },
          }).then(function (res) {
              if (res.data.code == 0) {
                that.$message.warning(res.data.msg);
              } else {
                that.dialogVisible2 = false
                that.BBBBB()
              }
          })  
        } else if (that.dialogVisible2_e == 4) {
          axios({
            method: 'post',
            url: '/admin/company/content/edit',
            data: {
              field_key: "leads_export_week", //内容标识
              content: ATT
            },
          }).then(function (res) {
              if (res.data.code == 0) {
                that.$message.warning(res.data.msg);
              } else {
                that.dialogVisible2 = false
                that.BBBBB()
              }
          })  
        } else if (that.dialogVisible2_e == 5) {
          axios({
            method: 'post',
            url: '/admin/company/content/edit',
            data: {
              field_key: "leads_export_one", //内容标识
              content: ATT
            },
          }).then(function (res) {
              if (res.data.code == 0) {
                that.$message.warning(res.data.msg);
              } else {
                that.dialogVisible2 = false
                that.BBBBB()
              }
          })  
        } else if (that.dialogVisible2_e == 6) {
          axios({
            method: 'post',
            url: '/admin/company/content/edit',
            data: {
              field_key: "leads_claim_num", //内容标识
              content: ATT
            },
          }).then(function (res) {
              if (res.data.code == 0) {
                that.$message.warning(res.data.msg);
              } else {
                that.dialogVisible2 = false
                that.BBBBB()
              }
          })  
        }
     
    },
    haeDete(index, row) {     // 删除导航类别
      var that = this
      console.log(row)
      var ATT = that.Categ
      if (row.type == 'default') {

      } else {
        for (let i = 0; i < ATT.length; i++) {
          const ele = ATT[i];
          if (ele.id == row.id) {
            ATT.splice(index,1);
          }
        }
        that.Categ = ATT
      }
    },
    haeDete2(index, row) {     // 删除导航类别   --------------全部线索管理
      var that = this
      console.log(row)
      var ATT = that.Categ2
      if (row.type == 'default') {

      } else {
        for (let i = 0; i < ATT.length; i++) {
          const ele = ATT[i];
          if (ele.id == row.id) {
            ATT.splice(index,1);
          }
        }
        that.Categ2 = ATT
      }
    },
    Chang_ses(e) {           // 切换我的线索
      var that = this
      that.type_Self = e
       let y1 =''
       let y2 =''
       if(that.Months1 != '') {
         y1 = that.formatDate(that.Months1);
       } 
       if(that.Months2 != '') {
         y2 = that.formatDate(that.Months2);
       }
      that.multipleSelection_id = null
      that.multipleSelection = []
      console.log(e)      
      axios({
        method: 'post',
        url: '/admin/order/order/index', 
        data: {
          page: 1,
          offset:0,
          limit:10,
          // type: that.type_Self,
          filter:{


            source_id: that.se_id,                        //订单来源id
            goods_id: that.wo_id,                         //销售项目ID
            pay_type: that.de_id,                         //支付方式ID

            site_id: that.te_id,                          // 站点id
            business_id: that.sa_id,                          // 服务商id
            pay_status: that.st_id,                       //支付状态，10=未支付,20=已支付
            is_confirm: that.co_id,                     //接单状态，10=未接单,20=已接单
            back_status: that.ba_id,                     //退款状态，10=未退款,20=退款中,30=已退款
            pay_form: that.pa_id,                     //付款形式，all=全款,part=部分
            time:{
              min:y1,
              max:y2,
            },
            money:{
              min:that.Months3,
              max:that.Months4,
            },
            keyword:that.input_seach
          }
        },
      }).then(function (res) {
        that.tableData = res.data.data.rows
        that.total1 = res.data.data.total
      })      
    },
    inpu_sech() {             // 搜索
      var that = this
       let y1 =''
       let y2 =''
       if(that.Months1 != '') {
         y1 = that.formatDate(that.Months1);
       } 
       if(that.Months2 != '') {
         y2 = that.formatDate(that.Months2);
       }
      axios({
        method: 'post',
        url: '/admin/order/order/index', 
        data: {
          page: 1,
          offset:0,
          limit:10,
          // type: that.type_Self,
          filter:{


            source_id: that.se_id,                        //订单来源id
            goods_id: that.wo_id,                         //销售项目ID
            pay_type: that.de_id,                         //支付方式ID

            site_id: that.te_id,                          // 站点id
            business_id: that.sa_id,                          // 服务商id
            pay_status: that.st_id,                     //支付状态，10=未支付,20=已支付
            is_confirm: that.co_id,                     //接单状态，10=未接单,20=已接单
            back_status: that.ba_id,                     //退款状态，10=未退款,20=退款中,30=已退款
            pay_form: that.pa_id,                     //付款形式，all=全款,part=部分
            time:{
              min:y1,
              max:y2,
            },
            money:{
              min:that.Months3,
              max:that.Months4,
            },
            keyword:that.input_seach
          }
        },
      }).then(function (res) {
        that.tableData = res.data.data.rows
        that.total1 = res.data.data.total
      })   
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
    },
    handleSelect_top (e) {
      if (e == 1) {
        this.$router.push('/Workbench/Manage');
      }else if (e == 2) {
        this.$router.push('/Workbench/Manage_2');
      } else if (e == 3) {
        this.$router.push('/Workbench/Manage_3');
      } else if (e == 4) {
        this.$router.push('/Workbench/Manage_4');
      }else if (e == 5) {
        this.$router.push('/Workbench/Manage_5');
      }
    },
    handleSelect(key, keyPath) {
      var that = this
      if (key == 1) {
        this.info_Show = 0
        if (that.Customer_id == 0) {

        } else {
          this.info_Show = 0;
          axios.get('/admin/customer/leads/read',{
                params:{
                  id: that.Customer_id
                }
            }).then(function (res) {
              if (res.data.code == 0) {
                // alert('请求失败');  
              } else { 
                that.Valuea_Xiansuo = res.data.data.row
                var arr = parseInt(res.data.data.row.demand_obj)
                var acc = []
                acc.push(arr)
                that.valueA_3 = acc
                that.full_avatar = res.data.data.row.imgs_url
                that.Row_Eurl = res.data.data.row.images
              }
          })
        }
        
      } else if(key == 2){
         this.info_Show = 1
        if (that.Customer_id == 0) {

        } else {
          this.info_Show = 1
            axios.get('/admin/customer/customer/read',{  
                  params:{
                    id: that.Customer_id
                  }
              }).then(function (res) {
                if (res.data.code == 0) {
                  alert('请求失败');  
                } else {
                  that.Valuea_Kehu = res.data.data.row
                  console.log(that.Valuea_Kehu)
                  var acc = []
                  var add = []

                  var arr1 = res.data.data.row.tag_obj
                  var arr2 = res.data.data.row.demand_obj
                  for (let i = 0; i < arr1.length; i++) {
                    acc[i]  =  parseInt(arr1[i]);
                  }
                  console.log(acc)
                  for (let i = 0; i < arr2.length; i++) {
                    add[i]  =  parseInt(arr2[i]);
                  }
                  that.valueA_sele1 = acc
                  that.valueA_sele2 = acc
                  that.full_avatar = res.data.data.row.imgs_url
                  that.Row_Eurl = res.data.data.row.images
                }
            }) 
        }
        
      } else if(key == 3){
        this.info_Show = 2
      } else if(key == 4){  
        this.info_Show = 3
      }
    },
    changeSwitch(data,b,index) {      // 是否启用
      var that = this
    },

    UP_Success(e) {  //图片上传成功
      var that = this
      console.log(e)
      that.Row_Eurl.push(e.data.url)
      that.aTY = 0
      console.log(that.Row_Eurl)
    },
    UP_Success2(e) {  //图片上传成功
      var that = this
      console.log(e)
      that.Row_Eurl2.push(e.data.url)
      that.aTY = 0
      console.log(that.Row_Eurl2)
    },
    HAndemove(file, fileList) {
      var that = this
      that.Row_Eurl = []
        console.log(fileList)
        for (let i = 0; i < fileList.length; i++) {
          const element = fileList[i];
          that.Row_Eurl.push(element.response.data.url)
         
        }
        console.log(that.Row_Eurl)
    },
    HAndemove2(file, fileList) {
      var that = this
      that.Row_Eurl2 = []
        console.log(fileList)
        for (let i = 0; i < fileList.length; i++) {
          const element = fileList[i];
          that.Row_Eurl2.push(element.response.data.url)
         
        }
        console.log(that.Row_Eurl)
    },

    handhange(e) {          // 勾选
      var that = this
      var arr = []
      var acc = []
      if (e.length == 0) {
        that.multipleSelection_id = null
      } else {
        for (let i = 0; i < e.length; i++) {
          const element = e[i];
          arr.push(element.id)
          acc.push(element)
        }
              that.multipleSelection_id = arr
      }


      that.multipleSelection = acc
    },
    HanDel(e, data) {       //单独删除
      var that = this 
      var arr = []
      arr.push(data.id)
      that.$confirm("确定要删除吗？", "提示", {
          type: "warning"
      }).then(() => {
            axios.delete('/admin/order/order/del',{ 
              params:{
                    ids: arr
              }
            }).then(function (res) {
            if (res.data.code == 0) {
                that.$message.warning(res.data.msg);
            } else{ 
                that.$message.success(res.data.msg);
                that.AAAAA()
            }
          })            
      })     
    },
    Add_Del(e) {             //批量操作
        var that = this
        var Att = that.multipleSelection
        if(e == 2) {           
          if (that.multipleSelection_id == null) {      //批量删除
            that.$message.warning('请勾选信息');
          } else {
            that.$confirm("确定要删除吗？", "提示", {
              type: "primary"
          }).then(() => {
            axios({
              method: 'delete',
              url: '/admin/order/order/del',
              data: {
                ids: that.multipleSelection_id
              },
            }).then(function (res) {
                if (res.data.code == 0) {
                  that.$message.warning(res.data.msg);
                } else {
                  that.$message.success(res.data.msg);
                  that.AAAAA()
                }
            }) 
          })
        }
        } else if (e == 5) {
          if (that.multipleSelection_id == null) {      //批量认领
            that.$message.warning('请勾选信息');
          } else {
            that.$confirm("确定要批量认领吗？", "提示", {
              type: "primary"
          }).then(() => {
            axios({
              method: 'post',
              url: '/admin/order/order/claim', 
              data: {
                ids: that.multipleSelection_id
              },
            }).then(function (res) {
              that.$message.success(res.data.msg);
              that.show1 = false
              that.AAAAA()        
            })  
          })
            
          }          
        }
    },

    saveEdit2(e) {                 //接单
      var that = this
        axios({
          method: 'post',
          url: '/admin/order/order/confirm', 
          data: {
            id: that.TA_name1_Arr.id,
            row:{
              time: that.TA_name22, //服务周期
              type: that.radio1, //周期类型: 天  月
              realname: that.TA_name11 //用户姓名
            }

          },
        }).then(function (res) {
            if (res.data.code == 0) {
              that.$message.warning(res.data.msg);
            } else{
                that.$message.success(res.data.msg);
                that.editVisible = false
                that.AAAAA()
             }
        })
    },
    saveEdit3(e) {                 //转移
      var that = this
        axios({
          method: 'post',
          url: '/admin/order/order/transfer', 
          data: {
            id: that.TA_name1_Arr.id,
            row:{
              business_id: that.TA_name333
            }
            
          },
        }).then(function (res) {
            if (res.data.code == 0) {
              that.$message.warning(res.data.msg);
            } else{
                that.$message.success(res.data.msg);
                that.editVisible3 = false
                that.AAAAA()
             }
        })
    },
    Handlbc_TH(e, data) {            //点击维护
      var that = this 
      that.show1 = true
    },
    HanEdit_SJ(e, data) {              //点击升级
      var that = this
     that.$confirm("确定要升级吗？", "提示", {
          type: "primary"
      }).then(() => {
        var arr = []
        arr.push(data.id)
        axios({
          method: 'post',
          url: '/admin/order/order/upgrade', 
          data: {
            ids:arr
          },
        }).then(function (res) {
          that.$message.success(res.data.msg);
          that.editVisible = false
          that.AAAAA()
        })
      })
    },
    HanEdit_SJ2(e, data) {              //点击接单
      var that = this
      that.editVisible2 = true
      that.TA_name1_Arr = data
    },
    HanEdit_SJ3(e, data) {              //转移
      console.log(data)
      var that = this
      that.editVisible3 = true
      that.TA_name1_Arr = data
      that.TA_name111 = data.goodsone.goods_name
      that.TA_name222 = data.order_no
    },
    Handmuiksd(e) {
      var that = this
      var att = []
      console.log(e) 
      console.log(that.Case_attse)
      for (let i = 0; i < that.Case_attse.length; i++) {
        const element = that.Case_attse[i];
        att.push(element[1])
      }
      that.valueA_5 = att
      console.log(att)
    },
    Handmuiksd2(e) {
      var that = this
      var att = []
      console.log(e) 
      console.log(that.File_Bid)
      for (let i = 0; i < that.File_Bid.length; i++) {
        const element = that.File_Bid[i];
        att.push(element[1])
      }
      that.valueA_5 = att
      console.log(att)
    },
    AAAAA() {                                   ////////////////111111111111111111111111111111111111111111
      var that = this
        axios({
          method: 'post',
          url: '/admin/order/order/index', 
          data: {
            page: 1,
            offset:0,
            limit:10,
            // type: that.type_Self,
          },
        }).then(function (res) {
          that.tableData = res.data.data.rows
          that.total1 = res.data.data.total
        })  
    },
    BBBBB() {
      var that = this
        axios.get('/admin/customer/config/statisticsColumns',{   // 设置选项 
              params:{
                type: 'order'
              }
          }).then(function (res) {
            if (res.data.code == 0) {
              alert('请求失败');  
            } else{ 
                  that.Config1 = res.data.data.claim_day
                  that.Config2 = res.data.data.claim_one
                  that.Config3 = res.data.data.flow_min
                  that.Config4 = res.data.data.export_week
                  that.Config5 = res.data.data.export_one
                  that.Config6 = res.data.data.claim_num
                
            }
        })  
    },
    handleCurrentChange1(val) {    // 分页 ···············································
      var that = this
      console.log(val)
      that.currentPage1 = val
       let y1 =''
       let y2 =''
       if(that.Months1 != '') {
         y1 = that.formatDate(that.Months1);
       }
        if(that.Months2 != '') {
         y2 = that.formatDate(that.Months2);
       }
      axios({
        method: 'post',
        url: '/admin/order/order/index', 
        data: {
          page: val,
          offset:0,
          limit:10,
          // type: that.type_Self,
          filter:{
            time:{
              min:y1,
              max:y2,
            },
            money:{
              min:that.Months3,
              max:that.Months4,
            },
            keyword:that.input_seach
          }
        },
      }).then(function (res) {
        that.tableData = res.data.data.rows
        that.total1 = res.data.data.total
      })      

    },
    formatDate(value) {    // 时间戳
        let date = new Date(value);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;

        return y + "-" + MM + "-" + d
    },
  },
};
</script>

<style>
.el-dropdown__caret-button {
    height: 34px!important;
    line-height: 0px;
    top: 3px;
}
.Spliiks .el-button{
    height: 26px!important;
    line-height: 2px;
    font-size: 11px;
}

.Spliiks .el-dropdown__icon {
  position: relative;
  top: -4px;
}
.Spliiks .el-dropdown__caret-button {
    height: 26px!important;
    line-height: 0px;
    top: 5px;
}
</style>
<style scoped>   
.Manage_3 .dasrttr .el-input {
  width: 220px;
}
.Manage_3 .Spliik /deep/ .el-button{
  padding: 8px;
}
</style>
